import { render } from "./CertificateCard.vue?vue&type=template&id=25d26934&scoped=true"
import script from "./CertificateCard.vue?vue&type=script&lang=js"
export * from "./CertificateCard.vue?vue&type=script&lang=js"

import "./CertificateCard.vue?vue&type=style&index=0&id=25d26934&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d26934"]])

export default __exports__